export const DEX_NONE_VALUE = 18446744073709551615n;
export const DEX_NONE_STR_VALUE = 'none';
export const DEX_ALL_VALUE = 18446744073709551614n;
export const DEX_RATE_REF_SYMBOL = 'USD';
export const DEX_EMPTY_ADDR = '0x0000000000000000000000000000000000000000';
